import {Document} from "../../document/document.model";
import {AttachmentModel} from "@Common/widgets/general/attachments/interfaces/attachment.model";

export interface Bel {
  id?: number;
  label?: string;
  state?: BelState;
  reference?: string;
  observations?: string;
  dir_cmp?: number;
  svc_dep?: number;
  documents_obj?: Document[];
  dt_created?: string;
  dt_updated?: string;
  bordereau_elimination?: number;
  bordereau_elimination_object?: AttachmentModel;
  bordereau_destruction?: number;
  bordereau_destruction_object?: AttachmentModel;
  content_type?: number;
}

export const belControls: [string, string][] = [
  ['label', 'label'],
  ['state', 'state'],
  ['observations', 'observations'],
  ['documents_obj', 'documents'],
];

export enum BelState {
  CONSTITUTION_REVISION = 1,
  SENDTOAD = 2,
  SENDTOSERVICES = 3,
  GOFORDESTRUCTION = 4,
  DESTROYED = 5
}
